import { createBillingAPI } from "../api/apiFactory";
import type { IBillingAPI } from "../api/billingApi";
import type { BillingSummaryResponse, OrgBillingSummaryResponse } from "@/types/Billing";

export class BillingService {
  public api: IBillingAPI;

  constructor(api?: IBillingAPI) {
    this.api = api || createBillingAPI();
  }

  async getMyBillingSummary(): Promise<BillingSummaryResponse> {
    return this.api.fetchMyBillingSummary();
  }

  async getOrganisationBillingSummary(orgId: string): Promise<OrgBillingSummaryResponse> {
    return this.api.fetchOrganisationBillingSummary(orgId);
  }
}
